<template>
    <v-container justify-center>
        <v-navigation-drawer permanent width="400px">
            <v-toolbar flat>
            <v-list>
                <v-list-tile>
                <v-list-tile-title class="title">
                    Account
                </v-list-tile-title>
                </v-list-tile>
            </v-list>
            </v-toolbar>

            <v-divider></v-divider>

            <v-list dense class="pt-0" two-line>
            <v-list-tile
                v-for="item in items1"
                :key="item.title"
                @click=""
                :to="item.link"
            >
                <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-navigation-drawer permanent width="400px">
            <v-toolbar flat>
            <v-list>
                <v-list-tile>
                <v-list-tile-title class="title">
                    Info and Feedback
                </v-list-tile-title>
                </v-list-tile>
            </v-list>
            </v-toolbar>

            <v-divider></v-divider>

            <v-list dense class="pt-0" two-line>
            <v-list-tile
                v-for="item in items2"
                :key="item.title"
                @click=""
            >
                <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            </v-list>
        </v-navigation-drawer>
    </v-container>
</template>


<script>
  export default {
    data () {
      return {
        items1: [
          { title: 'Profile', icon: 'person'},
          { title: 'Account', icon: 'question_answer', link:"/Account" },
          { title: 'Notifications', icon: 'notifications'},
          { title: 'History', icon: 'hourglass_full'}
        ],
        items2: [
          { title: 'Terms and Conditions', icon: 'subject'},
          { title: 'Feedback', icon: 'feedback'},
          { title: 'Rate', icon: 'star'},
          { title: 'Contributions', icon: 'supervised_user_circle'},
        ],
        right: null
      }
    }
  }
</script>

<style scoped>
</style>
